module.exports = {
	"header.navigation.sports": "Sports",
	"header.navigation.live": "Live",
	"header.navigation.cybersport": "Esports",
	"header.navigation.results": "Results",
	"header.navigation.fastsport": "Quick games",
	"header.navigation.promotions": "Bonuses & Promotions",
	"header.navigation.more": "More",
	"header.help": "Help",
	"header.locale.choose": "Select language:",
	"header.menu.menu_text": "Menu",
	"header.menu.company_news": "Company news",
	"header.menu.regulations": "Terms & conditions",
	"header.menu.responsible_game": "Responsible gaming",
	"header.menu.contact_information": "Contact information",
	"header.menu.betting_shop": "List of betting shops",
	"header.menu.players_best_bets": "Top winnings",
	"header.menu.internet_bonus": "Bonuses & promotions",
	"header.menu.privacy_policy": "Privacy policy",
	"header.user_menu.title": "Profile",
	"header.user_menu.account_num": "Account ID",
	"header.user_menu.recharge": "Deposit",
	"header.user_menu.briefcase": "Bank",
	"header.user_menu.bet_history": "Bet history",
	"header.user_menu.account_history": "Account history",
	"header.user_menu.withdraw": "Withdraw",
	"header.user_menu.opex_checks": "«Opex» checks",
	"header.user_menu.usdt_checks": "«USD₮» checks",
	"header.user_menu.profile": "My profile",
	"header.user_menu.bonus": "Bonus",
	"header.user_menu.logout": "Logout",
	"header.freebet.title.default": "A free bet (free bet) is available to you for the amount of {sum}{currency}\nStart of action from {start}\nEnd of action to {end}",
	"header.freebet.title.promocode": "A free bet (free bet) is available to you by promo code {promocode} for the amount of {sum}{currency}\nstart of action from {start} \nend of action before {end}",
	"header.freebet.max_factor": "Use it to place any bets with max odd {maxFactor}.",
	"header.freebet.valid_thru": "Valid from {startDate}",
	"header.freebet.valid_until": "Expires on {expireDate}",
	"header.freebet.details": "Read more about Free Bet",
	"header.games": "Games",
	"header.gamesFromVivo": "Vivo Games",
	"notification.new_message.new_message": "New message",
	"notification.new_message.proceed_to_messages": "Messages",
	"notification.new_message.close": "Close",
	"menu.bookmarks": "Favorites",
	"menu.others": "Others",
	"menu.all_sport": "All sports",
	"menu.popular_sport": "Popular Sports",
	"menu.calendar": "Live Events Schedule",
	"grid.menu.title": "Event menu",
	"grid.menu.collapse_all_events": "Collapse all events",
	"grid.menu.expand_all_events": "Expand all events",
	"grid.menu.collapse_all_groups": "Collapse all additional bets",
	"grid.menu.expand_all_groups": "Expand all additional bets",
	"grid.menu.display_line_numbers": "Display line numbers",
	"grid.menu.hide_line_numbers": "Hide line numbers",
	"grid.menu.prematch_filter.title": "Show",
	"grid.menu.prematch_filter.all_time": "All events",
	"grid.menu.prematch_filter.next_hour": "Started in 1 hour",
	"grid.menu.prematch_filter.next_2_hours": "Started in 2 hours",
	"grid.menu.prematch_filter.next_4_hours": "Started in 4 hours",
	"grid.menu.prematch_filter.next_6_hours": "Started in 6 hours",
	"grid.menu.prematch_filter.next_12_hours": "Started in 12 hours",
	"grid.menu.prematch_filter.next_day": "Started in 1 day",
	"grid.menu.prematch_filter.next_2_days": "Started in 2 days",
	"grid.header.event": "Sports betting",
	"grid.header.win1": "W1",
	"grid.header.draw": "X",
	"grid.header.win2": "W2",
	"grid.header.win1_draw": "1X",
	"grid.header.win12": "12",
	"grid.header.draw_win2": "X2",
	"grid.header.handicap": "HAN",
	"grid.header.handicap1": "1",
	"grid.header.handicap2": "2",
	"grid.header.under": "UND",
	"grid.header.total": "TOT",
	"grid.header.over": "OVR",
	"grid.header.live_bets_online": " live betting online",
	"grid.header.football": "Football",
	"grid.header.tennis": "Tennis",
	"grid.header.cybersport": "Cybersport",
	"grid.header.hockey": "Hockey",
	"grid.header.basketball": "Basketball",
	"grid.header.volleyball": "Volleyball",
	"grid.header.handball": "Handball",
	"grid.header.boxing": "Online boxing betting",
	"grid.header.UFC_MMA": "Betting on UFC and MMA online",
	"grid.header.american_football": "Online American Football Betting",
	"grid.header.table_tennis": "Online table tennis betting",
	"grid.header.live.matches": "Live matches",
	"grid.match-current-time.forward": "{minute}'",
	"grid.match-current-time.backward": "< {minute}' rem.",
	"grid.match-current-scores.not_started": " Match not started",
	"grid.match-current-scores.finished": " Match finished",
	"grid.match.datetime_at": "at",
	"grid.match.today": "Today",
	"grid.match.tomorrow": "Tomorrow",
	"play.stream.video": "Live Streaming Available",
	"login.to.watch": "Please log in to view",
	"timetable.title": "Upcoming Live Events Schedule",
	"timetable.time_filter": "All events",
	"timetable.sort_by_time": "Sort by time",
	"timetable.sort_by_league": "Sort by competition",
	"timetable.matches_filter_menu.title": "Show",
	"timetable.matches_filter_menu.no_filter": "All events",
	"timetable.matches_filter_menu.one_hour": "Started in 1 hour",
	"timetable.matches_filter_menu.two_hours": "Started in 2 hours",
	"timetable.matches_filter_menu.four_hours": "Started in 4 hours",
	"timetable.matches_filter_menu.six_hours": "Started in 6 hours",
	"timetable.matches_filter_menu.twelve_hours": "Started in 12 hours",
	"timetable.matches_filter_menu.one_day": "Started in 1 day",
	"timetable.matches_filter_menu.two_days": "Started in 2 days",
	"betpanel.title": "Bets",
	"betpanel.help": "To select a bet click on any price.",
	"coupon.title": "New Bet",
	"coupon.make_bet": "Place Bet",
	"coupon.rate_unavailable": "Rate unavailable",
	"coupon.stake_title": "Outcome:",
	"coupon.rate_title": "Odd:",
	"coupon.rate_changed": "Odd changed",
	"coupon.confirm_rate_value_change": "Accept",
	"coupon.stake_hint": "Stake",
	"coupon.min_amount_hint": "Min.",
	"coupon.max_amount_hint": "Max. {amount} {resource}",
	"coupon.bet_type_hint": "Bet type",
	"coupon.total_odd_hint": "Total odd",
	"coupon.possible_winning_hint": "Possible winning",
	"coupon.possible_winning_hint_short": "To return",
	"coupon.not_possible_stake": "This bet is not possible",
	"coupon.menu.title": "Bet settings",
	"coupon.menu.one-click_checkbox": "One-click bet",
	"coupon.menu.one-click_amount": "Stake",
	"coupon.menu.accept_factor_increase": "Accept the increase in odds",
	"coupon.menu.accept_factor_decrease": "Accept the decrease in odds",
	"coupon.menu.accept_total_and_handicap_change": "",
	"coupon.menu.favouriteBets": "Set favorite stake amounts",
	"coupon.menu.favouriteBet": "Stake {num}",
	"coupon.sum_label": "Sum",
	"coupon_bet_promocode_not_found1": "Promo code not found",
	"coupon_bet_for_get_freebet_fill_balance21": "To get a free bet you need to top up your account in the amount of {amount} {currency}",
	"coupon_bet_for_using_freebet_make_stake_more22": "To use the free bet, you must place a bet of at least {amount} {currency}",
	"coupon_bet_for_using_freebet_nessery_auth24": "To use the free bet, account identification is required",
	"coupon_bet_for_stake_type32": "Applies to bet type: {amount}",
	"coupon_bet_not_for_stake_type37": "Not applicable for this match",
	"coupon_bet_not_for_the_league38": "Not applicable to this league",
	"coupon_bet_min_coef_should33": "The minimum odd must be {amount}",
	"coupon_for_using_freebet_nesessarry_choose_more35": "To use a free bet, you must select at least {amount} events",
	"coupon_bet_nessary_should_more23": "Bets amount must exceed {amount}",
	"coupon_bet_coef_stakes_changed2": " Odds have been changed",
	"coupon_bet_validation_is_not_accept31": "Promo code is only available in {value}",
	"coupon_bet_freebet_sum_not_equal_sum_stake36": "Free bet amount is lower/higher than the bet amount",
	"coupon_bet_validation_is_not_accept_by_minCoef34": "The odd should not exceed {amount}",
	"bet_type.ordinar": "Single",
	"bet_type.accumulator": "Combo",
	"bet_type.looseToWinAccumulator": "Lose-to-Win Combo",
	"bet_type.system": "System {rank} of {count}",
	"bet_title.new_bet": "New bet",
	"bet_status.not_accepted": "Not Accepted",
	"bet_status.accepted": "Unsettled",
	"bet_status.canceled": "Canceled",
	"bet_status.sold": "Sold",
	"bet_status.won": "Won",
	"bet_status.lost": "Lost",
	"bet_history.refund": "Refund",
	"bet_history.bet_under_consideration": "Please wait...",
	"bet_history.bet_under_consideration_tooltip": "Bet is under consideration",
	"bet_history.sell": "Cash out",
	"bet_history.sell_cancel": "Cancel",
	"bet_history.cashout_amount_changed": "Cashout amount changed",
	"bet_history.cashout_confirmation": "Confirm bet cash out",
	"bet_history.event_stake_cashout_forbidden": "Event stake cashout is forbidden",
	"bet_history.rates_changed": "Rates<br/>changed",
	"bet_history.big_stake_cancel": "Cancel bet",
	"bet_history.rate": "Odd: ",
	"bet_history.stake": "Outcome: ",
	"bet_history.errors.insufficient_funds": "Insufficient funds",
	"bet_history.errors.account_locked": "Account is locked",
	"bet_history.errors.system_not_allowed_for_freebet": "'System' is not allowed for Freebet",
	"bet_history.errors.incorrect_stake_data": "Wrong stake data",
	"bet_history.errors.min_stake_amount": "Min stake amount {minAmount} {currency}",
	"bet_history.errors.incorrect_virtual_stake": "Incorrect virtual stake",
	"bet_history.errors.incorrect_freebet_stake": "Incorrect FreeBet stake",
	"bet_history.errors.existing_active_stake": "System error",
	"bet_history.errors.no_big_stake_permission": "Big stake not allowed",
	"bet_history.errors.freebet_big_stake": "Big FreeBet stakes denied",
	"bet_history.errors.bet_not_accepted_by_terms": "To use this bonus, you need to fulfill the conditions specified in the promo code description.",
	"news.read_title": "Read",
	"news.company_news": "Company News",
	"live.error.connection_lost": "Connection failure, please standby",
	"popular.title": "Popular sports betting",
	"popular.win1": "W1",
	"popular.draw": "X",
	"popular.win2": "W2",
	"header.signin.join_title": "Join now",
	"header.signin.title": "Sign In",
	"sign_in.phone": "Phone",
	"sign_in.email": "E-mail",
	"sign_in.login": "Login",
	"sign_in.or": "or",
	"sign_in.title": "Log in to Existing Account",
	"sign_in.requisite": "Requisite",
	"sign_in.password": "Password",
	"sign_in.log_in": "Sign In",
	"sign_in.resend_activation": "Send",
	"sign_in.join": "Join now",
	"sign_in.forgot": "Forgot username or password",
	"sign_in.activation_sent": "The message with activation link has been sent to {email}",
	"sign_in.errors.invalid_credentials": "Incorrect username or password",
	"sign_in.errors.user_blocked": "Too many attempts. Please try again in 15 minutes",
	"sign_in.errors.internal": "Error occured. Please contact tech support",
	"sign_in.errors.not_activated": "Your account is not activated. Send activation link to {email} again?",
	"sign_in.errors.wrong_certificate": "Your certificate has been blocked. Please contact tech support",
	"password_recovery.title": "Account recovery",
	"password_recovery.sent_to": "Password recovery instructions were sent to <strong>{email}</strong>",
	"password_recovery.sent_repeatedly": "We've sent a message with password recovery information to <strong>{email}</strong> several times. For security reasons, please contact our customer care service.",
	"password_recovery.sms_exceeded": "We've sent a message to your number with account recovery information twice. Please wait for the SMS, or else contact our customer care service.",
	"password_recovery.delivery_condition": "If you do not receive message from us in 5 minutes, check the 'Spam' folder",
	"password_recovery.support": "Otherwise, contact support via online chat",
	"password_recovery.registration_requisite": "Enter either username, account number, e-mail address or phone number (in format {mask}), you have used to register the account with:",
	"password_recovery.requisite": "Requisite",
	"password_recovery.recover_title": "Recover",
	"password_recovery.sent_via_sms": "Password was sent to <strong>{phone}</strong>",
	"password_recovery.support_phone": "If you do not receive SMS in the next few minutes, contact customer support via online chat",
	"password_recovery.errors.invalid_credentials": "User not found",
	"password_recovery.errors.internal_error": "Internal error",
	"password_recovery.errors.blocked": "Too many requests. Please try again in 15 minutes",
	"footer.fairplay.copyright": "&copy; {year} FairPlay Bookmaker Company",
	"footer.fairplay.copyright_kz": "&copy; {year} BETtery LLP. Trade mark \"Fair Play\" License # 320 issued on 23.08.2019",
	"footer.fairplay.copyright_ringobet": "&copy; {year} «TakeBet» LLP. Trade mark \"RingoBet\" License # 34 issued on 12.07.2022",
	"join.fast_registration_title": "Quick registration",
	"join.registration_title": "Regular registration",
	"join.title": "Open account",
	"join.login": "Username",
	"join.password": "Password",
	"join.password_repeat": "Retype password",
	"join.first_name": "First name",
	"join.last_name": "Last name",
	"join.dob": "Date of birth",
	"join.email": "E-mail",
	"join.phone": "Mobile phone",
	"join.city": "City",
	"join.country": "Country",
	"join.currency": "Account currency",
	"join.language": "Language",
	"join.timezone": "Timezone",
	"join.promo": "Promo code",
	"join.have_promo": "Have promo code?",
	"join.button_join": "Join now",
	"join.tac_agree": "I am at least 18 years old (for Kazakhstan citizen: at least 21 years old) and I have read, accept and agree to the <a href=\"{rulesLink}\" target=\"_blank\">Terms & Conditions</a>. I also allow to process my personal data using automated devices as described in <a href=\"{privacyLink}\" target=\"_blank\">Privacy Policy</a>",
	"join.real_info_warning": "Warning! Please provide your real personal data, which should match with your identity document (passport, driving license) when withdrawing winnings. You won’t be able to edit your credentials after account creation.",
	"join.link_sent_to": "Activation link was sent to {email}",
	"join.fast.type": "Register by",
	"join.fast.type.sms": "SMS",
	"join.fast.type.email": "Email",
	"join.fast.phone": "Mobile phone",
	"join.fast.email": "Email",
	"join.fast.currency": "Account currency",
	"join.fast.button_join": "Join now",
	"join.fast.tac_agree": "By pressing on this button you agree with the <a href=\"{rulesLink}\" target=\"_blank\">terms and conditions</a> of the company, <a href=\"{privacyLink}\" target=\"_blank\">privacy policy</a> and confirm that you are of legal age.",
	"join.fast.tac_agree_ringo": "By pressing on this button you agree with the <a href=\"{rulesLink}\" target=\"_blank\">terms and conditions</a> of the company, <a href=\"{privacyLink}\" target=\"_blank\">privacy policy</a> and confirm that you are over 21.",
	"join.fast.phone_confirm.title": "Phone number confirmation",
	"join.fast.phone_confirm.confirm_button": "Confirm",
	"join.fast.phone_confirm.confirmation_code": "Confirmation code",
	"join.fast.phone_confirm.sms_received_text": "SMS with confirmation code was sent to you. Use it to confirm your phone number. Please note that SMS delivery may take more than a minute.",
	"join.fast.phone_confirm.sms_sent_text": "Message was sent. ",
	"join.fast.phone_confirm.sms_resendinfo_text": "You will be able to resend it in {seconds} seconds. ",
	"join.fast.phone_confirm.call_resendinfo_text": "You can request confirmation again after {seconds} seconds.",
	"join.fast.phone_confirm.sms_resend_text": "Send SMS with code again",
	"join.fast.phone_confirm.call_resend_text": "Request confirmation again.",
	"join.fast.phone_confirm.sms_resend_button_text": "Send SMS",
	"join.fast.phone_confirm.call_resend_button_text": "Request",
	"join.fast.success.text": "Your account was successfully activated!",
	"join.fast.success.recharge_text": "Deposit and start playing",
	"join.fast.success.btn_recharge_text": "Deposit",
	"join.errors.internal": "Error occured. Try again later",
	"join.errors.smsexceeded": "We've sent a message to your number with account confirmation twice. Please wait for the SMS, or enter your e-mail and we'll send you information about account confirmation.",
	"join.errors.login_taken": "Username is taken",
	"join.errors.email_taken": "E-mail is already registered",
	"join.errors.phone_taken": "Cell phone is already registered",
	"join.errors.phone_not_found": "Invalid phone number",
	"join.errors.required_field": "Required field",
	"join.errors.promo_length_error": "Maximum 4 symbols",
	"join.errors.login_requirements": "At least 4 symbols, english letters and numbers",
	"join.errors.passwords_not_equal": "Passwords do not match",
	"join.errors.email_invalid": "Invalid email",
	"join.errors.invalid_promo": "Invalid promo code",
	"join.errors.phone_invalid": "Invalid phone number",
	"join.errors.age_incorrect": "Invalid birth date",
	"join.errors.age_illegal": "Illegal age",
	"join.errors.date_invalid": "Invalid birth date",
	"join.password_changed": "Password changed",
	"join.fast.phone_confirm.errors.confirmation_fail": "Error during confirmation, try again",
	"join.fast.phone_confirm.errors.sms_exceeded": "We've sent a message to your number with account confirmation twice. Please wait for the SMS, or enter your e-mail and we'll send you information about account confirmation.",
	"join.fast.phone_confirm.errors.invalid_code": "Invalid confirmation code",
	"phone_confirm.title": "Phone number confirmation",
	"phone_confirm.phone": "Mobile phone number",
	"phone_confirm.sms_text": "Confirmation code will be sent via SMS to the specified cell phone",
	"phone_confirm.confirm_button": "Confirm",
	"phone_confirm.denial": "I’m not interested, create the account without bonus",
	"phone_confirm.conditions": "You need to confirm your cell phone to participate in bonus-actions",
	"phone_confirm.confirmation_code": "Confirmation code",
	"phone_confirm.sms_received_text": "Enter the confirmation code from the SMS sent to number {phone}",
	"phone_confirm.success": "Phone number {phone} successfully confirmed!",
	"phone_confirm.start_playing": "Start Betting Now",
	"phone_confirm.errors.confirmation_fail": "Error during confirmation, try again",
	"phone_confirm.errors.phone_taken": "Cell phone is already registered",
	"phone_confirm.phone_hint": "Use international prefix",
	"special_offers.site146_proposal": "You are eligible to apply for a “1000 KZT Welcome Bonus” with the promo code you have entered in the previous step! <br />Please confirm your mobile phone number to receive the bonus. We will send an SMS to the following number with a confirmation code, which you will need to enter during the next step.",
	"special_offers.site146_accepted": "The bonus has been applied to your account.",
	"pages.main.title": "FairPlay - Bookmaker Company",
	"pages.main.description": "FairPlay - Bookmaker Company",
	"pages.live.title": "FairPlay - Bookmaker Company",
	"pages.live.description": "FairPlay - Bookmaker Company",
	"pages.sports.title": "Ставки на спорт в интернет-букмекере №1 в Казахстане — FairPlay",
	"pages.sports.description": "Сделать ставку онлайн очень просто — укажите интересующее вас спортивное событие, выберите желаемый исход и введите сумму ставки. Заключите пари прямо сейчас!",
	"pages.timetable.title": "Спортивные трансляции. Расписание предстоящих матчей.",
	"pages.timetable.description": "Список онлайн трансляций спортивных событий, для которых возможны букмекерские ставки.",
	"betpanel.unauth.how_to_bet": "How to Place a Bet?",
	"betpanel.unauth.to_configure_coupon": "To modify betslip settings, please",
	"betpanel.unauth.auth_or_register": "{signTrigger} or {joinTrigger} to start betting.",
	"betpanel.unauth.time_to_bet": "Now it’s time to place a bet!",
	"betpanel.unauth.sign_trigger": "Sign in",
	"betpanel.unauth.join_trigger": "register",
	"betpanel.unauth.to_place_bet": "To place the bet please",
	"betpanel.unauth.should_auth": "Sign in",
	"betpanel.unauth.should_register": "Join now",
	"betpanel.unauth.auth_or_register_to_bet": "{signTrigger} or {joinTrigger}",
	"timezones.item_1": "Asia/Almaty",
	"timezones.item_2": "Europe/Moscow",
	"create-password.modla-title": "Create password",
	"create-password.profile_password_form_new_password_label": "New password",
	"create-password.profile_password_form_retype_password": "Retype new password",
	"create-password.profile_password_form_btn_msg": "Save",
	"create-password.limit_form_error_empty_field": "Required",
	"create-password.password_form_error_mismatch": "Password confirmation didn't match",
	"create-password.password_changed": "Password changed",
	"betgames.disclaimer1": "All bets placed on BetgamesTV games are bets placed on real upcoming events. These bets do not relate to the term \"gambling\" as defined by the Gaming Law and are therefore not categorised as being of an online-casino nature.",
	"betgames.disclaimer2": "\"Fair Play\" does not participate in the organization of BetgamesTV events and neither the bookmaker, nor its customers are involved at any stage of the events process. The organizer of BetgamesTV events is the company \"TV ZAIDIMAI\". All BetgamesTV events are able to be viewed by customers as they take place via live streams. Neither the bookmaker, not its customers have any influence over the results of the events, which are organized independently and are published on official websites pertaining to the organizer.",
	"games.virtual-sport": "Virtual sports",
	"games.auth-required": "Authorization required",
	"games.vivo_games": "Live casino - roulette, poker, blackjack, baccarat…",
	"games.red_rake": "Slots, Bingo, Poker, Roulette",
	"games.leap_gaming": "Virtual sports, Horse and Dog Racing, Slots",
	"games.vivo_slots": "Slot games",
	"games.tv_bet": "TV games - blackjack, poker, keno, wheel...",
	"games.fastsport": "Quick sport",
	"games.tv_bet_roullette": "Live Roulette",
	"games.xpress": "Slots, casino, live games",
	"games.jacktop": "Live poker, blackjack, baccarat",
	"games.jacktop.black_jack": "Blackjack",
	"games.jacktop.roulette": "Roulette",
	"games.jacktop.poker": "Poker",
	"games.jacktop.baccarat": "Baccarat",
	"games.back_to_games": "Back to all games",
	"games.back_to_slots": "Back to slot games",
	"games.new": "New Games",
	"games.more": "See 20 More",
	"games.all_slots": "All Slots",
	"game.search": "search",
	"games.featured": "Featured Games",
	"games.name_of_games": "Game Name",
	"games.all": "All",
	"games.gamesSlots": "Gaming slot machines",
	"games.sport_vfl": "Football League",
	"games.sport_vfcc": "Football Champions Cup",
	"games.sport_vfwc": "Football World Cup",
	"games.sport_vfc": "Football Euro Cup 2020",
	"games.sport_vfac": "Football Asian Cup",
	"games.sport_vbl": "Basketball League",
	"verify_form.title": "Upload or drag and drop images. The document should fit within the frame entirely, and the information should be legible.",
	"verify_form.available_files": "Available files: image/jpeg, image/png",
	"verify_form.max_file_size": "Max file size: 20.00 MB",
	"verify_form.document_front_side": "Front side of the document",
	"verify_form.document_back_side": "Back side of the document",
	"verify_form.selfie_with_document": "Selfie with the document",
	"verify_form.submit": "Submit",
	"promocode.error.not_found": "Promocode not found",
	"promocode.error.not_active": "Promocode or channel is not active",
	"promocode.error.used": "Promocode has already been used",
	"promocode.error.not_available": "Promocode is not available",
	"promocode.title": "Promocode",
	"promocode.tab": "Promocodes",
	"promocode.enter": "Enter promocode",
	"promocode.apply": "Apply",
	"bonus.banner_title": "Double your winnings",
	"bonus.banner_text": "Place multiple bets and we'll double your winnings!",
	"instagram.banner.iphone_title": "Instagram promotion @fairplay",
	"instagram.banner.freebet_text": "FREEBET GIVEAWAY",
	"instagram.banner.center_text": "Instagram promo",
	"newGames.showAllGames": "View all games",
	"newGames.showRecentGames": "View recent games",
	"newGames.showFavorites": "View favorite games",
	"newGames.allTypes": "All types",
	"newGames.allProviders": "All providers",
	"newGames.popular": "Popular",
	"newGames.showAll": "View all",
	"newGames.searchGame": "Search by game name",
	"newGames.goBackToGames": "Back to games",
	"newGames.allGamesForCategory": "All games for category",
	"newGames.favoriteGames": "Favorite games",
	"newGames.recentGames": "Recent games",
	"newGames.recentGamesNot": "You have no recent games",
	"newGames.favoriteGamesNot": "You have no favorite games",
	"newGames.showMore": "Show more",
	"newGames.allGames": "All Games",
	"newGames.New": "New",
	"newGames.Hot": "Hot"
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/localization/en.json
// module id = 1830
// module chunks = 2